import React from 'react';
import { Link } from 'react-router-dom';
import Hero from '../components/Hero';
import Features from '../components/Features';
import Stats from '../components/Stats';

const Home = () => {
    return (
        <div className="flex flex-col flex-grow">
        <Hero />
        <Features />
        <Stats />

        {/* CTA Section - Grows to fill space */}
        <section className="bg-primary-700 flex-grow flex items-center">
        <div className="container-width py-12 text-center w-full">
        <h2 className="text-3xl md:text-4xl font-light text-white mb-4">
        Ready to Migrate with Confidence?
        </h2>
        <p className="text-lg text-white/90 mb-8">
        Get a free consultation and migration assessment today
        </p>
        <Link to="/contact" className="bg-white text-primary-700 px-8 py-3 rounded font-medium hover:bg-gray-100 transition-colors inline-block">
        Start Your Migration
        </Link>
        </div>
        </section>
        </div>
    );
};

export default Home;
